/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warning': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.597 4.496l10.996 19a3 3 0 01-2.596 4.503H5.003a3 3 0 01-2.596-4.503l10.996-19a3.002 3.002 0 015.194 0zm-3.305 7.796A1 1 0 0015 13v5a1 1 0 002 0v-5a1 1 0 00-1.707-.707zm-.125 11.455a1.5 1.5 0 101.667-2.495 1.5 1.5 0 00-1.667 2.495z" _fill="#0B2C62"/>'
  }
})
